import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEdit = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-298.67 -348.44 2133.33 2488.89",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		transform: "matrix(1 0 0 -1 0 1536)",
		d: "M363 0 454 91 219 326 128 235V128H256V0ZM886 928Q886 950 864 950Q854 950 847 943L305 401Q298 394 298 384Q298 362 320 362Q330 362 337 369L879 911Q886 918 886 928ZM832 1120 1248 704 416 -128H0V288ZM1515 1024Q1515 971 1478 934L1312 768L896 1184L1062 1349Q1098 1387 1152 1387Q1205 1387 1243 1349L1478 1115Q1515 1076 1515 1024Z"
	})
});
export default SvgEdit;
